module.exports = __webpack_public_path__ + "img/house-icon.ce5b3e2.png";